const ua = window.navigator.userAgent;

export const isMobile = ua.indexOf('Mobi') > -1 || ua.indexOf('iPh') > -1 || ua.indexOf('480') > -1;
export const isTablet = ua.indexOf('Tablet') > -1 || ua.indexOf('Pad') > -1 || ua.indexOf('Nexus 7') > -1;
export const isPC = !isMobile && !isTablet;

export const isIOS = ua.indexOf('like Mac OS X') > -1;
export const isAndroid = ua.indexOf('Android') > -1 || ua.indexOf('Adr') > -1;

export const isAlipay = ua.indexOf('AliApp(AP') > -1;
export const isWechat = ua.indexOf('MicroMessenger') > -1;
